import TypeOfWasteIcon from './component'

export default TypeOfWasteIcon
